<template>
    <component :is="api_key" :currentTimeZone="Intl.DateTimeFormat().resolvedOptions().timeZone" @logout="this.$store.dispatch('logout')"></component>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapGetters } from "vuex"
export default {
    name: 'NavbarComp',
    computed: {
        ...mapGetters(['omsApiKey']),
        api_key() {
            return defineAsyncComponent(() => import(`../../layouts/${this.omsApiKey}/components/Dashboard/Navbar.vue`))
        }
    }
}
</script>